import { toggleBodyScroll } from '../base/utils';
import Slider from './slider';
import Popup from './popup';

class Gallery {
    constructor($gallery) {
        this.REVEAL_COUNT = 6;

        this.$itemsWrap = $gallery;
        this.$galleryWrap = $gallery.parentNode;
        this.$items = $gallery.querySelectorAll('.gallery-item');
        this.$counter = $gallery.querySelector('.gallery-counter');

        this.buildGallery();
        // this.buildPopup();

        this.events();
    }

    events() {
        [...this.$items].forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                if (e.target.classList.contains('gallery-counter')) {
                    this.reveal();
                } else {
                    this.openPopup(el.dataset.id);
                }
            });
        });

        document.body.addEventListener('keydown', this.handleEsc.bind(this));
    }

    reveal() {
        let $hidden = [...this.$itemsWrap.querySelectorAll('.gallery-item-hidden')],
            hiddenCount = $hidden.length,
            n = Math.min(this.REVEAL_COUNT, hiddenCount),
            leftCount = hiddenCount - n,
            $item;

        for (let i = 0; i < n; i++) {
            $item = $hidden.shift();
            $item.classList.remove('gallery-item-hidden');
        }

        if (leftCount > 0) {
            this.$counter.innerHTML = `+${leftCount}`;
            $item.appendChild(this.$counter);
        } else {
            this.$counter.remove();
        }
    }

    buildGallery() {
        this.inlineGallery = new Slider(this.$galleryWrap, {
            slidesPerView: 1,
            center: true,
            loop: true,
            navigation: true,
            wrapperClass: 'gallery',
            slideClass: 'gallery-item',
            preloadImages: false,
            lazy: true,
            pagination: {
                el: '.gallery-pagination',
                type: 'fraction',
            },
            breakpoints: {
                768: {
                    disable: true
                }
            }
        });
    }

    buildPopup() {
        let html = '<div class="popup gallery-popup"><button class="popup-close close"></button><div class="gallery-slider"><div class="swiper-wrapper">';

        [...this.$items].forEach(el => {
            html += `<div class="gallery-popup-item swiper-slide">
<!--                <div class="gallery-popup-img" style="background-image: url('${el.href}')"></div>-->
                <img src="${el.href}" alt="" class="gallery-popup-img" />
            </div>`;
        });

        html += '</div></div></div>';

        this.$popup = document.createElement('div');
        this.$popup.className = 'popup-overlay';
        this.$popup.style.visibility = 'hidden';
        this.$popup.insertAdjacentHTML('beforeend', html);
        document.body.appendChild(this.$popup);
        this.$gallerySlider = this.$popup.querySelector('.gallery-slider');

        this.$gallerySlider.insertAdjacentHTML('afterbegin', `<div class="slider-navigation hidden">
            <button class="button-prev" aria-controls="" aria-label="poprzedni"><div class="arrow arrow-prev"></div></button>
            <button class="button-next" aria-controls="" aria-label="następny"><div class="arrow arrow-next"></div></button>
        </div>`);

        this.gallerySlider = new Slider(this.$gallerySlider, {
            slidesPerView: 1,
            loop: false,
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev'
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        setTimeout(() => {this.$popup.style.visibility = '';}, 300);

        this.$popup.querySelector('.popup-close').addEventListener('click', this.closePopup.bind(this));
        this.$popup.addEventListener('click', this.handleOverlayClick.bind(this));
    }

    openPopup(goToSlide = 0) {
        if (!this.$popup) {
            this.buildPopup();
        }

        this.gallerySlider.slider.slideTo(goToSlide, 0);

        // toggleBodyScroll(true);
        Popup.open(this.$popup);
        this.$popup.classList.add('popup-just-opened');
        setTimeout(() => { this.$popup.classList.remove('popup-just-opened'); }, 1500);
    }

    closePopup() {
        Popup.close(this.$popup);
        // toggleBodyScroll(false);
    }

    handleEsc(e) {
        let isEsc;

        if ("key" in e) {
            isEsc = (e.key === "Escape" || e.key === "Esc");
        } else {
            isEsc = (e.keyCode === 27);
        }

        if (isEsc) {
            this.closePopup();
        }
    }

    handleOverlayClick(e) {
        if (!e.target.classList.contains('gallery-popup-img') &&
            !e.target.closest('.slider-navigation') &&
            !e.target.classList.contains('popup-close')
        ) {
            this.closePopup();
        }
    }
}

export default Gallery;
